/**
 * Pre-React bootstrap failure UI.
 * Config/theme are unavailable here — keep fonts to ones already linked in public/index.html.
 */

import './bootstrapError.css';

function escapeHtml(raw: string): string {
  return raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderBootstrapError(rootElement: HTMLElement, err: unknown): void {
  const detail =
    err instanceof Error
      ? err.message
      : typeof err === 'string'
        ? err
        : 'Something unexpected prevented the site from starting.';

  rootElement.innerHTML = `
    <div class="ua-boot-err" role="alert">
      <div class="ua-boot-err__panel">
        <p class="ua-boot-err__eyebrow">Unwonted Artistry</p>
        <h1 class="ua-boot-err__title">This site is taking a moment</h1>
        <p class="ua-boot-err__lead">
          We couldn’t load the site configuration just now. Please try again in a moment.
          If you manage this site, confirm the latest release is deployed from CMC.
        </p>
        <div class="ua-boot-err__actions">
          <button type="button" class="ua-boot-err__btn" id="ua-boot-err-retry">Try again</button>
        </div>
        <details class="ua-boot-err__details">
          <summary>Technical details</summary>
          <p class="ua-boot-err__detail-body">${escapeHtml(detail)}</p>
        </details>
      </div>
    </div>
  `;

  const retry = rootElement.querySelector('#ua-boot-err-retry');
  retry?.addEventListener('click', () => {
    window.location.reload();
  });
}
